import React from 'react';
import { User } from '../../../../models';

interface EmployeeCheckProps {
  employee: User;
  handleCheck: (employee: User) => void;
  checked: boolean;
}

function EmployeeCheck({ employee, handleCheck, checked }: EmployeeCheckProps) {
  return (
    <div className="flex w-auto  items-center ml-1">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          handleCheck(employee);
        }}
        className="w-4 h-4 mt-1 cursor-pointer bg-white rounded border-purple-200 focus:ring-purple-300 focus:ring-2 "
      />
      <label className="ml-4 text-text-black mt-1">
        {employee.firstName} {employee.lastName}
      </label>
    </div>
  );
}

export default EmployeeCheck;
